import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热播排行</h2>
          <p className="mt-2 text-sm text-foreground-500">实时更新，看看大家都在看什么</p>
        </div>
        <div className="max-w-2xl mx-auto bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href={`#ranking`}
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 hover:bg-background-200/50 transition-colors cursor-pointer no-underline ${
                idx !== rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold shrink-0 ${
                item.rank === 1 ? 'bg-accent-500 text-background-50 dark:text-foreground-950' :
                item.rank === 2 ? 'bg-primary-500 text-background-50 dark:text-foreground-950' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50 dark:text-foreground-950' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.change === 'new' && (
                    <span className="shrink-0 px-1.5 py-0.5 text-[10px] font-bold bg-accent-100 text-accent-600 rounded">NEW</span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.type}</p>
              </div>
              <div className="text-right shrink-0">
                <div className="flex items-center gap-1 text-accent-500">
                  <i className={`text-xs ${item.change === 'up' ? 'ri-arrow-up-line' : item.change === 'down' ? 'ri-arrow-down-line text-foreground-500' : 'ri-subtract-line text-foreground-400'}`}></i>
                  <span className="text-sm font-bold">{item.score}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.heat}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}